import { render, staticRenderFns } from "./TVSingle.vue?vue&type=template&id=eb149292&scoped=true&"
import script from "./TVSingle.vue?vue&type=script&lang=js&"
export * from "./TVSingle.vue?vue&type=script&lang=js&"
import style0 from "./TVSingle.vue?vue&type=style&index=0&id=eb149292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb149292",
  null
  
)

export default component.exports